"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createLog;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("../utils");
var _logo = _interopRequireDefault(require("../logo"));
var _renderedContent = _interopRequireDefault(require("./renderedContent"));
var _template = _interopRequireDefault(require("../template"));
var style = require("./log_css.js")["default"];
function createLog(_ref) {
  var wapp = _ref.wapp;
  function defaultRender() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wapp = p.wapp,
      req = p.req,
      res = p.res,
      _p$parent = p.parent,
      parent = _p$parent === void 0 ? _template["default"] : _p$parent,
      _p$logo = p.logo,
      logo = _p$logo === void 0 ? _logo["default"] : _p$logo;
    var styles = wapp.styles;
    var _req$wappRequest = req.wappRequest,
      remoteAddress = _req$wappRequest.remoteAddress,
      httpVersion = _req$wappRequest.httpVersion,
      method = _req$wappRequest.method,
      url = _req$wappRequest.url,
      timestamp = _req$wappRequest.timestamp;
    var _res$wappResponse = res.wappResponse,
      _res$wappResponse$sta = _res$wappResponse.statusCode,
      statusCode = _res$wappResponse$sta === void 0 ? 200 : _res$wappResponse$sta,
      _res$wappResponse$sta2 = _res$wappResponse.statusMessage,
      statusMessage = _res$wappResponse$sta2 === void 0 ? "" : _res$wappResponse$sta2,
      _res$wappResponse$err = _res$wappResponse.errorMessage,
      errorMessage = _res$wappResponse$err === void 0 ? "" : _res$wappResponse$err;
    var text = p.text || "[LOG] [".concat(timestamp, " - ").concat(remoteAddress, "] HTTP:").concat(httpVersion, " ").concat(method, " ").concat(url || "/", " -> [").concat(statusCode, "] ").concat(errorMessage || statusMessage);
    styles.use(style);
    var renderedLog = "\n            <div class=\"".concat(style.log, "\">\n                <div class=\"").concat(style.logo, "\">\n                    ").concat(logo ? logo({
      wapp: wapp
    }) : "", "\n                </div>\n                <div>").concat(text, "</div>\n            </div>");
    if (parent) {
      return parent((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
        children: renderedLog
      }));
    }
    return renderedLog;
  }
  function defaultHandle(a, b, c, d) {
    var error = null;
    var req = a;
    var res = b;
    var next = null;
    if (arguments.length === 3) {
      if (typeof c === "function") {
        next = c;
      } else {
        error = a;
        req = b;
        res = c;
      }
    } else if (arguments.length === 4) {
      error = a;
      req = b;
      res = c;
      next = d;
    }
    var _req$wappRequest2 = req.wappRequest,
      httpVersion = _req$wappRequest2.httpVersion,
      method = _req$wappRequest2.method,
      url = _req$wappRequest2.url,
      remoteAddress = _req$wappRequest2.remoteAddress,
      _req$wappRequest2$tim = _req$wappRequest2.timestamp,
      timestamp = _req$wappRequest2$tim === void 0 ? Date.now() : _req$wappRequest2$tim;
    var _res$wappResponse2 = res.wappResponse,
      _res$wappResponse2$st = _res$wappResponse2.statusCode,
      statusCode = _res$wappResponse2$st === void 0 ? "" : _res$wappResponse2$st,
      _res$wappResponse2$st2 = _res$wappResponse2.statusMessage,
      statusMessage = _res$wappResponse2$st2 === void 0 ? "" : _res$wappResponse2$st2;
    var errorMessage = error && error.stack ? error.stack : error && error.message ? error.message : typeof error == "string" ? error : "";
    var text = "[LOG] [".concat(timestamp, " - ").concat(remoteAddress, "] HTTP:").concat(httpVersion, " ").concat(method, " ").concat(url || "/", " -> [").concat(statusCode, "] ").concat(errorMessage || statusMessage);
    if (res._consoledResponse !== text) {
      Object.defineProperty(res, "_consoledResponse", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        enumerable: false,
        value: text
      }));
      console.log(text);
    }
    if (next) {
      return next(error);
    }
    return text;
  }
  var logProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    render: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultRender
    }),
    renderedContent: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: _renderedContent["default"]
    })
  });
  function logMiddleware(err, req, res, next) {
    if (typeof logMiddleware.handle === "function") {
      return logMiddleware.handle.apply(logMiddleware, arguments);
    }
    return logMiddleware;
  }
  (0, _utils.mergeProperties)(logMiddleware, logProperties);
  Object.defineProperty(logMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "log", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    value: logMiddleware
  }));
  return logMiddleware;
}